<template>

  <div class="px-3">
    <RegistrarEnvioProcesos
      :saveInState="saveProcesosInState"
      :esIess="esCoberturaIess"
      :maxEnvios="maxEnvios"
      :tokenAtencion="tokenAtencion"
      alertNoRegistros
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { RegistrarEnvioProcesos } from '@/views/procesoclinico/components';
import { citasService } from '../../services';

export default {

  components: {
    RegistrarEnvioProcesos
  },



  created() {
    this.getTokenAtencion();
  },


  data() {
    return {
      procesosList: [],
      tokenAtencion: null
    }
  },


  methods: {

    async getTokenAtencion() {
      
      this.tokenCita = this.$route.params.token;

      if(!this.tokenCita) return;

      const responseAtencion = await citasService.getAtencion(this.tokenCita);

      if(!responseAtencion || !responseAtencion.length){
        console.error('No se encontraro una atencion');
        return;
      }

      this.tokenAtencion = responseAtencion[0].token;
    },


    saveProcesosInState(procesosList) {
      this.$store.commit("setDataEnvioProcesos", procesosList);
    }
  },


  computed: {
    ...mapState({
      stDataCobertura: state => state.citas?.ingresoCitas?.dataInfoCita?.cobertura,
    }),


    esCoberturaIess() {
      const esCoberturaIess = this.stDataCobertura === '1'
      return esCoberturaIess;
    },


    maxEnvios() {
      return this.stDataCobertura === '5' ? null : 1;
    }
  },
}
</script>
